import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=3260c66b&scoped=true&"
import script from "./FileDropZone.vue?vue&type=script&lang=ts&"
export * from "./FileDropZone.vue?vue&type=script&lang=ts&"
import style0 from "./FileDropZone.vue?vue&type=style&index=0&id=3260c66b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260c66b",
  null
  
)

export default component.exports